export default __webpack_public_path__ + "static/media/Jim.505d1f7a.png";